import template from './backup_manager_report_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class BackupManagerReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class BackupManagerReportHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new BackupManagerReportHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'BackupManagerReportHelp',
	dialog_class: BackupManagerReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/backup_manager_report_help',
	provider: 'ps'
};
